import moment from 'moment'
import { currency } from '@/filters'
import { getPartnerRegulationLink } from '@/api/headersSettings.js'

export function getPrice (isPromo, { olderTotalValue, totalValue }) {
  return isPromo ? olderTotalValue : totalValue
}

function getValueUnit (totalValue, totalNumberOfPassengers) {
  return Number(totalValue / totalNumberOfPassengers.toFixed(2))
}

export function getPassengers (passengers, isAdditional) {
  return passengers.map(passenger => {
    const firstName = passenger.name.split(' ').slice(0, 1).join(' ')
    const lastName = passenger.name.split(' ').slice(1).join(' ')

    if (passenger.isUnderThen18) {
      passenger.legalResponsible = {
        firstName: passenger.nameLegalResponsible.split(' ').slice(0, 1).join(' '),
        lastName: passenger.nameLegalResponsible.split(' ').slice(1).join(' '),
        cpf: passenger.cpfLegalResponsible
      }

      delete passenger.cpf
    }

    let defaultPassengers = {
      ...firstName && { firstName },
      ...lastName && { lastName },
      ...passenger.cpf && { cpf: passenger.cpf },
      ...passenger.legalResponsible && {
        legalResponsible: passenger.legalResponsible
      },
      dateOfBirth: passenger.dateOfBirth,
      gender: passenger.gender,
      phone: passenger.phone
    }

    if (isAdditional) {
      defaultPassengers = {
        name: `${firstName} ${lastName}`,
        cpf: passenger.isUnderThen18 ? passenger.cpfLegalResponsible : passenger.cpf,
        dateOfBirth: passenger.dateOfBirth
      }
    }

    return defaultPassengers
  })
}

function getDestination (codDestination, state) {
  const countriesSelected = state.quotation.countriesSelected.map(({ label }) => label)

  return /Y(30|15)/.test(codDestination)
    ? `Multitrip ${codDestination.slice(-2)}`
    : countriesSelected.length === 1
      ? countriesSelected[0]
      : `${countriesSelected.slice(0, -1).join(', ')} e ${countriesSelected.slice(-1)}`
}

export function getPromoCode ({ valid, value }) {
  return {
    applied: valid,
    code: (valid && value) || '',
    enable: false,
    error: null,
    ...!valid && { default: value }
  }
}

export function getTotalPriceExamPCR (currentValue, totalNumberOfPassengers) {
  const totalValue = totalNumberOfPassengers * currentValue

  return currency(totalValue)
}

export function getDataLayer (state, selectedQuote, getters) {
  const ecommerceDataLayer = [
    {
      item: 'durantion',
      value: moment(state.quotation.endDate)
        .diff(state.quotation.initialDate, 'days')
    },
    {
      item: 'packageLabel',
      value: selectedQuote.packageLabel
    },
    {
      item: 'period',
      value: `${state.quotation.initialDate} - ${state.quotation.endDate}`
    },
    {
      item: 'transactionProducts',
      value: [
        {
          sku: selectedQuote.uuid,
          name: state.quotation.destinationId,
          category: 'Seguro Viagem',
          price: getValueUnit(selectedQuote.totalValue, getters['quotation/totalNumberOfPassengers']),
          quantity: getters['quotation/totalNumberOfPassengers']
        },
        {
          ...state.additional.pcr.active && {
            sku: `${Math.random()}--${selectedQuote.uuid}--${Math.random()}`, // Alterar quando a lista de serviços adicionais for dinâmica (API).
            name: 'Exame PCR (Covid 19)',
            category: 'Seguro Viagem',
            price: state.additional.pcr.currentValue['price'],
            quantity: state.additional.pcr.listSelectedPassengers.length
          }
        }
      ]
    },
    {
      item: 'coberturaCovid',
      value: state.quotation.planCovidSelected !== null
    }
  ]

  return ecommerceDataLayer
}

function getScoringProgram (selectedQuote, getters) {
  return {
    enable: true,
    partnerName: getters['quotation/partnerName'],
    points: selectedQuote.liveloPoints || selectedQuote.dotzPoints,
    regulationLink: getPartnerRegulationLink()
  }
}
function mergeCovidCovers (selectedCovidCover, selectedQuoteCovidPlan) {
  const covidPlan = { ...selectedQuoteCovidPlan }
  if (selectedCovidCover.checkoutLabel) {
    covidPlan.checkoutLabel = selectedCovidCover.checkoutLabel
  }
  return covidPlan
}

export function getPlan (state, selectedQuote, isPromo, getters) {
  return {
    lblDestination: getDestination(state.quotation.destinationId, state),
    numberOfPassengersNinetyNineYears:
      state.quotation.numberOfPassengersNinetyNineYears,
    numberOfPassengersEightyFiveYears:
      state.quotation.numberOfPassengersEightyFiveYears,
    numberOfPassengersFourtyYears:
      state.quotation.numberOfPassengersFourtyYears,
    numberOfPassengersSeventyFiveYears:
      state.quotation.numberOfPassengersSeventyFiveYears,
    numberOfPassengersSixtyFourYears:
      state.quotation.numberOfPassengersSixtyFourYears,
    packageLabel: selectedQuote.packageLabel,
    parcelasPrecos: selectedQuote.installmentValue
      ? selectedQuote.installmentValues.reverse()
      : [getPrice(isPromo, selectedQuote)],
    passengers: getPassengers(state.user.passengers),
    ...((selectedQuote.dotzPoints || selectedQuote.liveloPoints) && {
      scoringProgram: getScoringProgram(selectedQuote, getters)
    }),
    preco: getPrice(isPromo, selectedQuote),
    precoTotal: state.additional.pcr.active
      ? state.additional.pcr.totalValue
      : selectedQuote.totalValue,
    promoCode: getPromoCode(state.quotation.promoCode),
    quotation: {
      ...(state.quotation.countries.length > 0 && {
        countries: state.quotation.countries
      }),
      codDestination:
        state.quotation.destinationId || state.quotation.codDestination,
      endDate: state.quotation.endDate,
      initialDate: state.quotation.initialDate,
      planName: selectedQuote.planName,
      insurer: state.quotation.insurer,
      // Cobertura covid
      ...selectedQuote.planCovid && {
        planCovid: mergeCovidCovers(
          getters['quotation/selectedCovidCovers'],
          selectedQuote.planCovid
        ),
        planComplementary: selectedQuote.planCovid.id
      },
      includeChip: selectedQuote.includeChip
    },
    uuid: selectedQuote.uuid,
    voucherRecipient: state.user.voucherRecipient
  }
}
